const { BlobServiceClient } = require("@azure/storage-blob");

const azure_uri = process.env.VUE_APP_AZURE_URI;
const azure_sas = process.env.VUE_APP_AZURE_SAS;

const containerName = "project";

async function upload(file) {
  if (!azure_uri || !azure_sas) {
    throw new Error(
      "Logo storage is not configured. Set VUE_APP_AZURE_URI and VUE_APP_AZURE_SAS at build time (not committed)."
    );
  }

  const blobServiceClient = new BlobServiceClient(`${azure_uri}${azure_sas}`);
  const containerClient = blobServiceClient.getContainerClient(containerName);

  let filename = (file.name || "logo").split(".");
  let fileext = filename.pop();

  const blobName = filename.join(".") + new Date().getTime() + "." + fileext;
  const blockBlobClient = containerClient.getBlockBlobClient(blobName);

  const options = { blobHTTPHeaders: { blobContentType: file.type || "application/octet-stream" } };

  await blockBlobClient.uploadBrowserData(file, options);

  const base = azure_uri.endsWith("/") ? azure_uri : azure_uri + "/";
  return `${base}project/` + blobName;
}

export { upload };
